import { render } from "./AdminSystemDialog.vue?vue&type=template&id=12812ab3&scoped=true"
import script from "./AdminSystemDialog.vue?vue&type=script&lang=js"
export * from "./AdminSystemDialog.vue?vue&type=script&lang=js"

import "./AdminSystemDialog.vue?vue&type=style&index=0&id=12812ab3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12812ab3"]])

export default __exports__